import React from 'react';
import { FaUser, FaLock } from 'react-icons/fa';

const LoginPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-pl_bg_light_5 to-pl_bg_light_3 flex items-center justify-center">
      <div className="bg-pl_bg_light_3 p-8 rounded-lg shadow-lg w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-pl_txt_light_1 mb-2">Welcome Back</h1>
          <p className="text-pl_txt_light_3">Please sign in to continue</p>
        </div>
        
        <form className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-pl_txt_light_2 mb-2">
              Email Address
            </label>
            <div className="relative">
              <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-pl_txt_light_3" />
              <input
                type="email"
                className="w-full pl-10 pr-4 py-3 border border-pl_border_light_1 rounded-lg bg-pl_bg_light_5 text-pl_txt_light_1 placeholder-pl_txt_light_3 focus:outline-none focus:ring-2 focus:ring-pl_prim_color_1 focus:border-transparent"
                placeholder="Enter your email"
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-pl_txt_light_2 mb-2">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-pl_txt_light_3" />
              <input
                type="password"
                className="w-full pl-10 pr-4 py-3 border border-pl_border_light_1 rounded-lg bg-pl_bg_light_5 text-pl_txt_light_1 placeholder-pl_txt_light_3 focus:outline-none focus:ring-2 focus:ring-pl_prim_color_1 focus:border-transparent"
                placeholder="Enter your password"
              />
            </div>
          </div>
          
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-pl_prim_color_1 to-pl_prim_color_2 text-pl_bg_light_3 py-3 px-4 rounded-lg font-semibold hover:from-pl_prim_color_2 hover:to-pl_prim_color_1 transition-all duration-200"
          >
            Sign In
          </button>
        </form>
        
        <div className="mt-6 text-center">
          <a href="/chatlogs" className="text-pl_prim_color_1 hover:text-pl_prim_color_2 text-sm">
            Back to Chat Logs
          </a>
        </div>
      </div>
    </div>
  );
};

export default LoginPage; 